import { type FC } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { DirectContactFormImageUploadField as DirectContactFormImageUploadControl } from '../../../direct-contact'
import { directContactFormAccessorIsImageUploadMandatory } from '../../model/directContactFormAccessorIsImageUploadMandatory'
import { directContactFormAccessorShouldShowImageUpload } from '../../model/directContactFormAccessorShouldShowImageUpload'

import { type DirectContactFormValues } from './DirectContactFormModel'

export const DirectContactFormImageUploadField: FC<{
  isLoggedIn: boolean
}> = ({ isLoggedIn }) => {
  const intl = useIntl()
  const { control } = useFormContext<DirectContactFormValues>()
  const orderId = useWatch({ control, name: 'orderId' })
  const subject = useWatch({ control, name: 'subject' })
  const selectedProducts = useWatch({
    control,
    name: 'selectedProducts',
  })
  const selectedProductTotalCost = selectedProducts.reduce(
    (total, product) => total + product.totalCost,
    0,
  )
  const shouldShowImageUpload = directContactFormAccessorShouldShowImageUpload({
    intl,
    isLoggedIn,
    subject,
  })

  if (!shouldShowImageUpload) {
    return null
  }

  const isMandatory = directContactFormAccessorIsImageUploadMandatory({
    intl,
    selectedProductTotalCost,
    subject,
  })

  return (
    <DirectContactFormImageUploadControl
      isMandatory={isMandatory}
      key={`${subject}-${orderId}`}
    />
  )
}
